import type React from 'react';
import { useEffect } from 'react';
import { useStoreMap } from 'effector-react';
import useInput from '@hooks/useInput';
import Button from '@components/Button';
import Input from '@components/Input';
import { $scenesManagement, $scenesManagementApi } from './stores';

function SearchBar() {
  const value = useStoreMap({
    store: $scenesManagement,
    keys: [],
    fn: (state) => state.query,
  });
  const queryInput = useInput<HTMLInputElement>('');

  useEffect(() => {
    if (!value) {
      queryInput.clear();
    }
  }, [value]);

  const search = () => {
    const val = queryInput.value.trim();
    if (!val) return;
    $scenesManagementApi.update((draft) => {
      draft.query = val;
      draft.selected = [];
    });
  };

  const clear = () => {
    $scenesManagementApi.update((draft) => {
      draft.query = '';
      draft.selected = [];
    });
    queryInput.clear();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      search();
    }
  };

  return (
    <div className="relative ml-10 flex items-center">
      <Input
        className="h-30 w-150"
        disabled={!!value}
        placeholder={value ? '' : '请输入关键字'}
        onKeyDown={handleKeyDown}
        onClear={value ? clear : undefined}
        {...queryInput.bind}
      />
      <Button className="ml-5" onClick={search}>
        搜索
      </Button>
    </div>
  );
}

export default SearchBar;
